import { Brands } from 'src/utils/enums/brands.enum';
import { Checkbox } from '../../../ui/checkbox';
import { CreditApplicationType } from 'src/utils/enums/financialTypes.enum';
import { useCreditForm } from 'src/customHooks/useCreditForm';
import { useLocalization } from 'src/utils/useLocalization';
import React, { Dispatch, SetStateAction } from 'react';

import './style.scss';

interface IAcknowledgement {
    brand: string;
    applicant: string;
    applicationType: string;
    setPipedaValue: Dispatch<SetStateAction<boolean>>;
    pipedaValue: boolean;
    isErrorPipeda: boolean;
    setContactValue: Dispatch<SetStateAction<boolean>>;
    contactValue: boolean;
    isErrorContact: boolean;
    isQuebec: boolean;
    setQuebecAssessment: Dispatch<SetStateAction<boolean>>;
    quebecAssessment: boolean;
    isErrorQuebecAssessment: boolean;
    setQuebecContract: Dispatch<SetStateAction<boolean>>;
    quebecContract: boolean;
    isErrorQuebecContract: boolean;
}

const Acknowledgement: React.FC<IAcknowledgement> = ({
    applicant,
    applicationType,
    brand,
    setPipedaValue,
    pipedaValue,
    isErrorPipeda,
    setContactValue,
    contactValue,
    isErrorContact,
    isQuebec,
    setQuebecAssessment,
    quebecAssessment,
    isErrorQuebecAssessment,
    setQuebecContract,
    quebecContract,
    isErrorQuebecContract,
}) => {
    const { creditAppOtherInformation } = useLocalization();
    const { markCreditFormTouched } = useCreditForm();
    const title = `${
        creditAppOtherInformation.ACKNOWLEDGEMENT_TITLE
    } ${selectApplicantType(applicationType, applicant)}`;
    const pipeda =
        brand === Brands.AUDI
            ? creditAppOtherInformation.ACKNOWLEDGEMENT_PIPEDA_AUDI
            : creditAppOtherInformation.ACKNOWLEDGEMENT_PIPEDA_VW;
    const contactMessage =
        brand === Brands.AUDI
            ? creditAppOtherInformation.ACKNOWLEDGEMENT_CONTACT_AUDI
            : creditAppOtherInformation.ACKNOWLEDGEMENT_CONTACT_VW;

    function selectApplicantType(type: string, applicant: string) {
        if (applicant === 'Primary') {
            switch (type) {
                case CreditApplicationType.INDIVIDUAL:
                case CreditApplicationType.JOINT:
                case CreditApplicationType.COAPP:
                    return creditAppOtherInformation.ACKNOWLEDGEMENT_PRIMARY;
                case CreditApplicationType.BUSINESS:
                case CreditApplicationType.BUSINESS_COAPP:
                case CreditApplicationType.BUSINESS_PG:
                    return creditAppOtherInformation.ACKNOWLEDGEMENT_BUSINESS;
                default:
                    return creditAppOtherInformation.ACKNOWLEDGEMENT_PRIMARY;
            }
        }

        switch (type) {
            case CreditApplicationType.JOINT:
                return creditAppOtherInformation.ACKNOWLEDGEMENT_JOINT;
            case CreditApplicationType.COAPP:
            case CreditApplicationType.BUSINESS_COAPP:
                return creditAppOtherInformation.ACKNOWLEDGEMENT_COAPP;
            case CreditApplicationType.BUSINESS_PG:
                return creditAppOtherInformation.ACKNOWLEDGEMENT_PG;
        }
    }

    return (
        <>
            <div className='o-fieldset__row'>
                <div className='o-layout'>
                    <div className='o-layout__item u-1/1 ack__title'>
                        {title}
                    </div>
                </div>
            </div>
            <div className='o-fieldset__row'>
                <div className='o-layout'>
                    <div className='o-layout__item u-1/1'>
                        {creditAppOtherInformation.ACKNOWLEDGEMENT_INSTRUCTIONS}
                    </div>
                </div>
            </div>
            <div className='o-fieldset__row'>
                <div className='o-layout'>
                    <div className='o-layout__item u-1/1'>
                        <div className='c-form-field'>
                            <div className='c-form-field__box'>
                                <div className='c-input column-direction'>
                                    <Checkbox
                                        name={pipeda}
                                        value={`pipeda${applicant}`}
                                        onCheck={(val: any) => {
                                            setPipedaValue(val);
                                            markCreditFormTouched();
                                        }}
                                        checked={pipedaValue}
                                        isError={isErrorPipeda}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='o-fieldset__row'>
                <div className='o-layout'>
                    <div className='o-layout__item u-1/1'>
                        <div className='c-form-field'>
                            <div className='c-form-field__box'>
                                <div className='c-input column-direction'>
                                    <Checkbox
                                        name={contactMessage}
                                        value={`contact${applicant}`}
                                        onCheck={(val: any) => {
                                            setContactValue(val);
                                            markCreditFormTouched();
                                        }}
                                        checked={contactValue}
                                        isError={isErrorContact}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isQuebec && (
                <>
                    <div className='o-fieldset__row'>
                        <div className='o-layout'>
                            <div className='o-layout__item u-1/1'>
                                <div className='c-form-field'>
                                    <div className='c-form-field__box'>
                                        <div className='c-input column-direction'>
                                            <Checkbox
                                                name={
                                                    creditAppOtherInformation.ACKNOWLEDGEMENT_QUEBEC_ASSESSMENT
                                                }
                                                value={`quebecAssesmnent${applicant}`}
                                                onCheck={(val: any) => {
                                                    setQuebecAssessment(val);
                                                    markCreditFormTouched();
                                                }}
                                                checked={quebecAssessment}
                                                isError={
                                                    isErrorQuebecAssessment
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='o-fieldset__row'>
                        <div className='o-layout'>
                            <div className='o-layout__item u-1/1'>
                                <div className='c-form-field'>
                                    <div className='c-form-field__box'>
                                        <div className='c-input column-direction'>
                                            <Checkbox
                                                name={
                                                    creditAppOtherInformation.ACKNOWLEDGEMENT_QUEBEC_CONTRACT
                                                }
                                                value={`quebecContract${applicant}`}
                                                onCheck={(val: any) => {
                                                    setQuebecContract(val);
                                                    markCreditFormTouched();
                                                }}
                                                checked={quebecContract}
                                                isError={isErrorQuebecContract}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default Acknowledgement;
